function t(t={},r){return Object.prototype.hasOwnProperty.call(t,r)}export{t as hasOwnProperty};
